import SmoothScroll from "smooth-scroll"
import tippy from "tippy.js"
import inView from "element-in-view"

import "./components/header"
import "./components/footer"
import "./components/verhalen-kennis-slider"
import "./components/logo-slider"
import "./components/accordion"
import "./components/single-accordion"

new SmoothScroll('a[href^="#"]', {
    speed: 300,
    offset: function () {
        return 100
    },
    easing: "Linear",
    ignore: 'a[href^="#openChat"]',
    topOnEmptyHash: false,
})

document.querySelectorAll('a[href^="#openChat"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
        e.preventDefault()
        console.log("Opening Tawk.to")
        if (window.Tawk_API) {
            window.Tawk_API.maximize()
        }
    })
})

document.querySelectorAll("[data-tooltip]").forEach((tooltip) => {
    tippy(tooltip, {
        content: tooltip.getAttribute("data-tooltip"),
        interactive: true,
        trigger: "click",
    })
})

function handleAnimations() {
    const animations = [
        "fadeInRight",
        "fadeInLeft",
        "fadeInBottomLeft",
        "fadeInBottomRight",
        "fadeInUp",
        "fadeInDown",
        "fadeIn",
        "pulse",
        "slideInUp",
        "headShake",
    ]

    let animatedElements = []

    animations.forEach((animation) => {
        const list = Array.from(document.querySelectorAll(`.${animation}`)).map(
            (element) => {
                element.style.visibility = "hidden"
                return {
                    element: element,
                    animation: animation,
                }
            }
        )

        animatedElements = [...animatedElements, ...list]
    })

    window.addEventListener("scroll", function () {
        animatedElements.forEach((animated) => {
            if (
                inView(animated.element, {
                    threshold: 0.5,
                })
            ) {
                animated.element.style.visibility = "visible"
                animated.element.classList.add("animate__animated")
                animated.element.classList.add(`animate__${animated.animation}`)
            }
        })
    })

    animatedElements.forEach((animated) => {
        if (
            inView(animated.element, {
                threshold: 0.5,
            })
        ) {
            animated.element.style.visibility = "visible"
            animated.element.classList.add("animate__animated")
            animated.element.classList.add(`animate__${animated.animation}`)
        }
    })
}

handleAnimations()
